import React from 'react';
import logo from '../../assets/logo.png';
import mobileLogo from '../../assets/mobile-logo.png';
import { switchLanguageAndSave } from '../../store/actions';
import { connect } from 'react-redux';
import './style.css';

class Header extends React.Component {
  render() {
    return (
      <div>
        <div className="header content">
          <div className="top-bar">
            <div className="top-bar__logo">
              <a href="https://beeline.kg/ru">
                <img className="logo" src={logo} alt="logo" />
                <img className="mobile-logo" src={mobileLogo} alt="logo" />
              </a>
            </div>
            <div className="languages">
              <div
                className={
                  this.props.langType === 'ru' ? 'languages--active' : ''
                }
                onClick={() => this.props.switchLanguage('ru')}
              >
                Русский
              </div>
              <div
                className={
                  this.props.langType === 'kg' ? 'languages--active' : ''
                }
                onClick={() => this.props.switchLanguage('kg')}
              >
                Кыргызча
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

export default connect(
  ({ language }) => ({
    header: language.header,
    langType: language.type
  }),
  dispatch => ({
    switchLanguage: dispatch(switchLanguageAndSave)
  })
)(Header);
